import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appScrollTo]',
  standalone: true,
})
export class ScrollToDirective implements AfterViewInit {
  @Input()
  scrollWhen: boolean = false;

  constructor(private el: ElementRef) {}

  public ngAfterViewInit(): void {
    const htmlElement: HTMLElement = this.el.nativeElement;
    if (this.scrollWhen) {
      setTimeout(() => {
        htmlElement.scrollIntoView({ block: 'center' });
      });
    }
  }
}
